import { render, staticRenderFns } from "./section4.vue?vue&type=template&id=2016f592"
import script from "./section4.vue?vue&type=script&lang=js"
export * from "./section4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports